// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_fIkungXW06WZ0tD_khTP","item":"Lvcr64lp-RMRgL5uJo-EL","description":"_1Z5JXdfsxRwHMYnAhLLaAD"};